var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { style: { minHeight: "700px" } },
        [
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("common.title") },
                        model: {
                          value: _vm.data.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "title", $$v)
                          },
                          expression: "data.title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          decimals: 0,
                          min: 1,
                          max: 5,
                          label: _vm.$ct("max-to-show-years"),
                        },
                        model: {
                          value: _vm.data.ToShowYears,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "ToShowYears", $$v)
                          },
                          expression: "data.ToShowYears",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-card-title", [_vm._v(" " + _vm._s(_vm.$ct("filters")) + ": ")]),
          _vm.browse && _vm.model
            ? _c("app-human-filter-list-edit", {
                attrs: { browse: _vm.browse, model: _vm.model },
                model: {
                  value: _vm.data.filters,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "filters", $$v)
                  },
                  expression: "data.filters",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }